module.exports = __webpack_public_path__ + "static/media/h-notification.c085c156.svg";